export enum TransferRequirementsEnum {
  movilization = "MOVILIZACIÒN",
  ventilation = "VENTILACIÒN"
}